import { render, staticRenderFns } from "./HelpCenterArticleSkeleton.vue?vue&type=template&id=da03214a&"
import script from "./HelpCenterArticleSkeleton.vue?vue&type=script&lang=js&"
export * from "./HelpCenterArticleSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports